import { render, staticRenderFns } from "./CGMView.vue?vue&type=template&id=eeb1e4f2&scoped=true"
import script from "./CGMView.vue?vue&type=script&lang=js"
export * from "./CGMView.vue?vue&type=script&lang=js"
import style0 from "./CGMView.vue?vue&type=style&index=0&id=eeb1e4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb1e4f2",
  null
  
)

export default component.exports